import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Table,
  TableColumnsType,
  TableProps,
} from "antd";
import React, { useContext } from "react";
import { useClient } from "../../../Context/ClientContext";
import { dayjs } from "../../../../Utilities/dayjs";
import ReportsServiceNew from "../../../Services/ReportsServiceNew";
import { notificationContext } from "../../../Common/PageRoute";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { voucherType } from "../VoucherDetailsByLedger";
import { getIndianStates } from "../../../Services/ClientService";
import { useTheme } from "../../../Context/ThemeContext";
import { Utils } from "../../../../Utilities/Utils";
import InvoiceExportService from "../../../Services/InvoiceExportDetails";
import { log } from "console";
import GSTR1 from "./GSTR1";
import GSTR2A from "./GSTR2A";
import { Report_Type, Report_TypeAction } from "../../../Services/UsersService";
import { useUser } from "../../../../Context/UserContext";
import { IAccessSettings } from "../../../../Types";

export enum GSTTableType {
  // [Display(Name = "4A - Supplies other than those attracting reverse charge (including supplies made through e-commerce operator attracting TCS)")]
  GSTR1_4A = 41,
  // [Display(Name = "4B - Supplies attracting tax on reverse charge basis")]
  GSTR1_4B,
  // [Display(Name = "5A - Outward supplies (including supplies made through e-commerce operator, rate wise)")]
  GSTR1_5A = 51,
  // [Display(Name = "6A - Exports")]
  GSTR1_6A = 61,
  // [Display(Name = "6B - Supplies made to SEZ unit or SEZ Developer")]
  GSTR1_6B,
  // [Display(Name = "6C - Deemed exports")]
  GSTR1_6C,
  // [Display(Name = "7A - Intra-State supplies (Consolidated rate wise outward supplies [including supplies made through e-commerce operator attracting TCS])")]
  GSTR1_7A = 71,
  // [Display(Name = "7B - Intra-State supplies where invoice value is upto Rs. 2.5 lakhs [Rate wise] (Consolidated rate wise outward supplies [including supplies made through e-commerce operator attracting TCS])")]
  GSTR1_7B,
  // [Display(Name = "Inter-State and Intra-State supplies to registered and unregistered persons")]
  GSTR1_8 = 81,
  // // [Display(Name = "Intra-State supplies to registered persons")]
  // GSTR1_8B,
  // // [Display(Name = "Inter-State supplies to unregistered persons")]
  // GSTR1_8C,
  // // [Display(Name = "Intra-State supplies to unregistered persons")]
  // GSTR1_8D,
  // [Display(Name = "")]
  GSTR1_9A = 91,
  // [Display(Name = "Intra-State supplies [including supplies made through e-commerce operator attracting TCS][Rate wise]")]
  GSTR1_10A = 101,
  // [Display(Name = "Inter-State supplies [including supplies made through e-commerce operator attracting TCS][Rate wise]")]
  GSTR1_10B,
  // [Display(Name = "Advance amount received in the tax period for which invoice has not been issued (tax amount to be added to output tax liability) - Intra-State supplies (Rate wise)")]
  GSTR1_11_I_A1 = 111,
  // [Display(Name = "Advance amount received in the tax period for which invoice has not been issued (tax amount to be added to output tax liability) - Inter-State supplies (Rate wise)")]
  GSTR1_11_I_A2,
  // [Display(Name = "Advance amount received in earlier tax period and adjusted against the supplies being shown in the tax period in Table Nos. 4, 5, 6 and 7 - Intra-State supplies (Rate wise)")]
  GSTR1_11_I_B1,
  // [Display(Name = "Advance amount received in earlier tax period and adjusted against the supplies being shown in the tax period in Table Nos. 4, 5, 6 and 7 - Inter-State supplies (Rate wise)")]
  GSTR1_11_I_B2,
  // [Display(Name = "Amendment of information furnished in Table No. 11(1) in GSTR-1 statement for earlier tax periods [Furnish revised information]")]
  GSTR1_11_II,
  // [Display(Name = "Supplies on which e-commerce operator is liable to collect tax u/s. 52")]
  GSTR1_14_a = 141,
  // [Display(Name = "Supplies on which e-commerce operator is liable to pay tax u/s. 9(5)")]
  GSTR1_14_b,
  // [Display(Name = "Supplies on which e-commerce operator is liable to collect tax u/s. 52")]
  GSTR1_14A_a,
  // [Display(Name = "Supplies on which e-commerce operator is liable to pay tax u/s. 9(5)")]
  GSTR1_14A_b,
  // [Display(Name = "Registered")]
  GSTR1_15A = 151,
  // [Display(Name = "Unregistered")]
  GSTR1_15B,
  // [Display(Name = "Inward supplies received from a registered person other than the supplies attracting reverse charge")]
  GSTR2A_3 = 231,
  // [Display(Name = "Inward supplies received from a registered person on which tax is to be paid on reverse charge")]
  GSTR2A_4,
  // [Display(Name = "Inward supplies received from a registered person on which tax is to be paid on reverse charge")]
  GSTR2A_5,
}

const GSTReports = () => {
  const { themeData } = useTheme();
  const { currentClient, companySettings } = useClient();
  const { accessSettings } = useUser();
  const useAccessSettingsData: IAccessSettings = accessSettings();
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const { RangePicker } = DatePicker;
  const { openNotification } = useContext(notificationContext);
  // const [reportType, setReportType] = React.useState<any>(0);
  const [loading, setLoading] = React.useState(false);
  const [gstTable4AReportsData, setGstTable4AReportsData] =
    React.useState<any>();
  const [gstTable4BReportsData, setGstTable4BReportsData] =
    React.useState<any>();
  const [gstTable5ReportsData, setGstTable5ReportsData] = React.useState<any>();
  const [gstTable6AReportsData, setGstTable6AReportsData] =
    React.useState<any>();
  const [gstTable6BReportsData, setGstTable6BReportsData] =
    React.useState<any>();
  const [gstTable6CReportsData, setGstTable6CReportsData] =
    React.useState<any>();
  const [gstTable7AReportsData, setGstTable7AReportsData] =
    React.useState<any>();
  const [gstTable7BReportsData, setGstTable7BReportsData] =
    React.useState<any>();
  const [gstTable8ReportsData, setGstTable8ReportsData] = React.useState<any>();

  const [gst2ATable3ReportsData, setGst2ATable3ReportsData] =
    React.useState<any>();
  const [gst2ATable4ReportsData, setGst2ATable4ReportsData] =
    React.useState<any>();

  const [selReport, setSelReport] = React.useState<string>("GST1");

  const [filterDate, setFilterDate] = React.useState<any>({
    from: dayjs(companySettings?.period?.from).format("DD/MM/YYYY"),
    to: dayjs(companySettings?.period?.to).format("DD/MM/YYYY"),
  });
  const [exportType, setExportType] = React.useState<number>(-1);
  const [exportGstData, setExportGstData] = React.useState<any[]>([]);

  React?.useEffect(() => {
    getGSTReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    filterDate?.from,
    filterDate?.to,
    exportType,
    selReport,
  ]);
  const getGSTReport = () => {
    setGstTable4AReportsData(null);
    setGstTable4BReportsData(null);
    setGstTable5ReportsData(null);
    setGstTable6AReportsData(null);
    setGstTable6BReportsData(null);
    setGstTable6CReportsData(null);
    setGstTable7AReportsData(null);
    setGstTable7BReportsData(null);
    setGstTable8ReportsData(null);
    setGst2ATable3ReportsData(null);
    setGst2ATable4ReportsData(null);

    if (currentClient?.id && (exportType === -1 || exportType)) {
      switch (selReport) {
        case "GST1":
          getGSTR1List(
            currentClient?.id,
            dayjs(filterDate?.from, "DD/MM/YYYY").toISOString(),
            dayjs(filterDate?.to, "DD/MM/YYYY").endOf("day").toISOString()
          );
          break;
        case "GST2A":
          getGSTR2AList(
            currentClient?.id,
            dayjs(filterDate?.from, "DD/MM/YYYY").toISOString(),
            dayjs(filterDate?.to, "DD/MM/YYYY").endOf("day").toISOString()
          );
          break;
        case "GST3B":
          break;
      }
    }
  };

  const getGSTR1List = async (
    clientId: string,
    fromDate: string = "",
    toDate: string = ""
  ) => {
    if (exportType < 1) {
      setLoading(true);
    }
    await ReportsServiceNew?.getGSTR1(clientId, fromDate, toDate).then(
      (res: any) => {
        let gstTable4A: any = [];
        let gstTable4B: any = [];
        let gstTable5: any = [];
        let gstTable6A: any;
        let gstTable6B: any = [];
        let gstTable6C: any = [];
        let gstTable7A: any = [];
        let gstTable7B: any = [];
        let gstTable8: any = [];
        if (res) {
          setLoading(false);
          let tmpTable4AData = res?.result?.table4n5.filter(
            (r: any) => r?.gstSupplyType === GSTTableType.GSTR1_4A
          );
          let tmpTable4BData = res?.result?.table4n5.filter(
            (r: any) => r?.gstSupplyType === GSTTableType.GSTR1_4B
          );
          let tmpTable5Data = res?.result?.table4n5.filter(
            (r: any) => r?.gstSupplyType === GSTTableType.GSTR1_5A
          );
          let tmpTable6AData = res?.result?.table6A;
          let tmpTable6BData = res?.result?.table6B;
          let tmpTable6CData = res?.result?.table6C;
          let tmpTable7AData = res?.result?.intraStateSupplies;
          let tmpTable7BData = res?.result?.interStateSupplies;
          let tmpTable8Data = res?.result?.table8;

          if (tmpTable4AData?.length > 0) {
            let gstData = tmpTable4AData?.map((r: any, rIndex: number) => {
              gstTable4A.push({
                partyGSTNo: r?.gstSupplyTypeName,
                rowType: 1,
                key: rIndex,
              });
              r?.vouchers?.map((v: any, vIndex: number) =>
                v?.taxDetail?.map((t: any, tIndex: number) =>
                  gstTable4A.push({
                    key: `${rIndex}${vIndex}${tIndex}`,
                    rowType: 0,
                    partyGSTNo: v?.partyGSTNo,
                    partyName: v?.partyName,
                    number: v?.number,
                    voucherType: voucherType[v?.voucherType],
                    hsnsac: t?.hsnsac,
                    date: dayjs(v?.date).format("DD-MM-YYYY"),
                    invoiceValue: v?.invoiceValue,
                    supplyState: getIndianStates(v?.supplyState),
                    taxableAmount: t?.taxableAmount,
                    igstAmt: t?.igstAmt,
                    cgstAmt: t?.cgstAmt,
                    sgstAmt: t?.sgstAmt,
                    rate:
                      t?.igstRate === 0
                        ? Number(t?.cgstRate) + Number(t?.sgstRate)
                        : t?.igstRate,
                  })
                )
              );
            });
          }
          if (tmpTable4BData?.length > 0) {
            let gstData = tmpTable4BData?.map((r: any, rIndex: number) => {
              gstTable4B.push({
                partyGSTNo: r?.gstSupplyTypeName,
                rowType: 1,
                key: rIndex,
              });
              r?.vouchers?.map((v: any, vIndex: number) =>
                v?.taxDetail?.map((t: any, tIndex: number) =>
                  gstTable4B.push({
                    key: `${rIndex}${vIndex}${tIndex}`,
                    rowType: 0,
                    partyGSTNo: v?.partyGSTNo,
                    partyName: v?.partyName,
                    number: v?.number,
                    voucherType: voucherType[v?.voucherType],
                    hsnsac: t?.hsnsac,
                    date: dayjs(v?.date).format("DD-MM-YYYY"),
                    invoiceValue: v?.invoiceValue,
                    supplyState: getIndianStates(v?.supplyState),
                    taxableAmount: t?.taxableAmount,
                    igstAmt: t?.igstAmt,
                    cgstAmt: t?.cgstAmt,
                    sgstAmt: t?.sgstAmt,
                    rate:
                      t?.igstRate === 0
                        ? Number(t?.cgstRate) + Number(t?.sgstRate)
                        : t?.igstRate,
                  })
                )
              );
            });
          }
          if (tmpTable5Data?.length > 0) {
            let gstData = tmpTable5Data?.map((r: any, rIndex: number) => {
              gstTable5.push({
                supplyState: r?.gstSupplyTypeName,
                rowType: 1,
                key: rIndex,
              });
              r?.vouchers?.map((v: any, vIndex: number) =>
                v?.taxDetail?.map((t: any, tIndex: number) =>
                  gstTable5.push({
                    key: `${rIndex}${vIndex}${tIndex}`,
                    rowType: 0,
                    supplyState: getIndianStates(v?.supplyState),
                    number: v?.number,
                    voucherType: voucherType[v?.voucherType],
                    date: dayjs(v?.date).format("DD-MM-YYYY"),
                    invoiceValue: v?.invoiceValue,
                    rate:
                      t?.igstRate === 0
                        ? Number(t?.cgstRate) + Number(t?.sgstRate)
                        : t?.igstRate,
                    taxableAmount: t?.taxableAmount,
                    igstAmt: t?.igstAmt,
                    cessAmt: t?.cessAmt,
                  })
                )
              );
            });
          }

          if (tmpTable6AData) {
            gstTable6A = tmpTable6AData;
          }
          if (tmpTable6BData) {
            gstTable6B = tmpTable6BData;
          }
          if (tmpTable6CData) {
            gstTable6C = tmpTable6CData;
          }
          if (tmpTable7AData?.length > 0) {
            let gstData = tmpTable7AData?.map((r: any, rIndex: number) => {
              gstTable7A.push({
                key: rIndex,
                totalCount: r?.totalCount,
                invoiceValue: r?.invoiceValue,
                taxableValue: r?.taxableValue,
                taxRate: r?.taxRate,
                igstAmt: r?.igstAmt,
                cgstAmt: r?.cgstAmt,
                sgstAmt: r?.sgstAmt,
                cessAmt: r?.cessAmt,
              });
            });
          }

          if (tmpTable7BData?.length > 0) {
            let gstData = tmpTable7BData?.map((r: any, rIndex: number) => {
              gstTable7B.push({
                supplyState: getIndianStates(r?.supplyState),
                totalCount: r?.totalCount,
                rowType: 1,
                key: rIndex,
              });
              r?.summary?.map((v: any, vIndex: number) =>
                gstTable7B.push({
                  key: `${rIndex}${vIndex}`,
                  rowType: 0,
                  invoiceValue: v?.invoiceValue,
                  taxableValue: v?.taxableValue,
                  taxRate: v?.taxRate,
                  igstAmt: v?.igstAmt,
                  cgstAmt: v?.cgstAmt,
                  sgstAmt: v?.sgstAmt,
                  cessAmt: v?.cessAmt,
                })
              );
            });
          }
          if (tmpTable8Data) {
            gstTable8.push({
              description: tmpTable8Data?.interStateRegSupplies?.displayText,
              nilRatedSupplies: tmpTable8Data?.interStateRegSupplies?.nil,
              exemptedSupplies: tmpTable8Data?.interStateRegSupplies?.exempted,
              nonGSTSupplies: 0,
            });
            gstTable8.push({
              description: tmpTable8Data?.intraStateRegSupplies?.displayText,
              nilRatedSupplies: tmpTable8Data?.intraStateRegSupplies?.nil,
              exemptedSupplies: tmpTable8Data?.intraStateRegSupplies?.exempted,
              nonGSTSupplies: 0,
            });
            gstTable8.push({
              description: tmpTable8Data?.interStateUnRegSupplies?.displayText,
              nilRatedSupplies: tmpTable8Data?.interStateUnRegSupplies?.nil,
              exemptedSupplies:
                tmpTable8Data?.interStateUnRegSupplies?.exempted,
              nonGSTSupplies: 0,
            });
            gstTable8.push({
              description: tmpTable8Data?.intraStateUnRegSupplies?.displayText,
              nilRatedSupplies: tmpTable8Data?.intraStateUnRegSupplies?.nil,
              exemptedSupplies:
                tmpTable8Data?.intraStateUnRegSupplies?.exempted,
              nonGSTSupplies: 0,
            });
          }
        }

        if (exportType >= 1) {
          // setExportGstData(gstData1);
          if (exportType === 1) {
            // exportCsv(gstData1);
          } else if (exportType === 2) {
            // exportPDF(gstData1);
          } else if (exportType === 3) {
            // exportExcel(gstData1);
          }
        } else {
          setGstTable4AReportsData(gstTable4A);
          setGstTable4BReportsData(gstTable4B);
          setGstTable5ReportsData(gstTable5);
          setGstTable6AReportsData(gstTable6A);
          setGstTable6BReportsData(gstTable6B);
          setGstTable6CReportsData(gstTable6C);
          setGstTable7AReportsData(gstTable7A);
          setGstTable7BReportsData(gstTable7B);
          setGstTable8ReportsData(gstTable8);
        }
      }
    );
  };

  const getGSTR2AList = async (
    clientId: string,
    fromDate: string = "",
    toDate: string = ""
  ) => {
    if (exportType < 1) {
      setLoading(true);
    }
    await ReportsServiceNew?.getGSTR2A(clientId, fromDate, toDate).then(
      (res: any) => {
        let gstTable3: any = [];
        let gstTable4: any = [];
        if (res) {
          setLoading(false);
          let tmpTable3Data = res?.result?.table3n4.filter(
            (r: any) => r?.gstSupplyType === GSTTableType.GSTR2A_3
          );
          let tmpTable4Data = res?.result?.table3n4.filter(
            (r: any) => r?.gstSupplyType === GSTTableType.GSTR2A_4
          );

          if (tmpTable3Data?.length > 0) {
            let gstData = tmpTable3Data?.map((r: any, rIndex: number) => {
              // gstTable3.push({
              //   partyGSTNo: r?.gstSupplyTypeName,
              //   rowType: 1,
              //   key: rIndex,
              // });
              r?.vouchers?.map((v: any, vIndex: number) =>
                v?.taxDetail?.map((t: any, tIndex: number) =>
                  gstTable3.push({
                    key: `${rIndex}${vIndex}${tIndex}`,
                    rowType: 0,
                    partyGSTNo: v?.partyGSTNo,
                    supplierInvoiceRef: v?.supplierInvoiceRef,
                    supplierInvoiceDate: v?.supplierInvoiceDate,
                    partyName: v?.partyName,
                    number: v?.number,
                    voucherType: voucherType[v?.voucherType],
                    hsnsac: t?.hsnsac,
                    date: dayjs(v?.date).format("DD-MM-YYYY"),
                    invoiceValue: Utils?.getFormattedNumber(v?.invoiceValue),
                    supplyState: getIndianStates(v?.supplyState),
                    taxableAmount: Utils?.getFormattedNumber(t?.taxableAmount),
                    igstAmt: Utils?.getFormattedNumber(t?.igstAmt),
                    cgstAmt: Utils?.getFormattedNumber(t?.cgstAmt),
                    sgstAmt: Utils?.getFormattedNumber(t?.sgstAmt),
                    rate:
                      t?.igstRate === 0
                        ? Number(t?.cgstRate) + Number(t?.sgstRate)
                        : t?.igstRate,
                  })
                )
              );
            });
          }
          if (tmpTable4Data?.length > 0) {
            let gstData = tmpTable4Data?.map((r: any, rIndex: number) => {
              // gstTable4.push({
              //   supplyState: r?.gstSupplyTypeName,
              //   rowType: 1,
              //   key: rIndex,
              // });
              r?.vouchers?.map((v: any, vIndex: number) =>
                v?.taxDetail?.map((t: any, tIndex: number) =>
                  gstTable4.push({
                    key: `${rIndex}${vIndex}${tIndex}`,
                    rowType: 0,
                    partyGSTNo: v?.partyGSTNo,
                    supplierInvoiceRef: v?.supplierInvoiceRef,
                    supplierInvoiceDate: v?.supplierInvoiceDate,
                    partyName: v?.partyName,
                    number: v?.number,
                    voucherType: voucherType[v?.voucherType],
                    hsnsac: t?.hsnsac,
                    date: dayjs(v?.date).format("DD-MM-YYYY"),
                    invoiceValue: Utils?.getFormattedNumber(v?.invoiceValue),
                    supplyState: getIndianStates(v?.supplyState),
                    taxableAmount: Utils?.getFormattedNumber(t?.taxableAmount),
                    igstAmt: Utils?.getFormattedNumber(t?.igstAmt),
                    cgstAmt: Utils?.getFormattedNumber(t?.cgstAmt),
                    sgstAmt: Utils?.getFormattedNumber(t?.sgstAmt),
                    rate:
                      t?.igstRate === 0
                        ? Number(t?.cgstRate) + Number(t?.sgstRate)
                        : t?.igstRate,
                  })
                )
              );
            });
          }
        }
        if (exportType >= 1) {
          // setExportGstData(gstData1);
          if (exportType === 1) {
            // exportCsv(gstData1);
          } else if (exportType === 2) {
            // exportPDF(gstData1);
          } else if (exportType === 3) {
            // exportExcel(gstData1);
          }
        } else {
          setGst2ATable3ReportsData(gstTable3);
          setGst2ATable4ReportsData(gstTable4);
        }
      }
    );
  };

  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => {});
  };

  let path = "GST Report";

  // const columnsA = [
  //   // First row (main headers)
  //   [
  //     { content: "GSTIN of Suppliers", rowSpan: 2 },
  //     { content: "Trade/Legal Name", rowSpan: 2 },
  //     { content: "Invoice Details", colSpan: 4 },
  //     { content: "Place of Suppliers", rowSpan: 2 },
  //     { content: "Supply Attract Reverse Charge", rowSpan: 2 },
  //     { content: "Rate(%)", rowSpan: 2 },
  //     { content: "HSN/SAC", rowSpan: 2 },
  //     { content: "Taxable Value", rowSpan: 2 },
  //     { content: "Tax Amount", colSpan: 3 },
  //   ],
  //   // Second row (subcolumns for Invoice Details and Tax Amount)
  //   [
  //     { content: "Invoice Number" },
  //     { content: "Invoice Type" },
  //     { content: "Invoice Date" },
  //     { content: "Invoice Value" },
  //     { content: "Integrated Tax" },
  //     { content: "Central Tax" },
  //     { content: "State/UT Tax" },
  //   ],
  // ];
  const columnsA = [
    { content: "GSTIN of Suppliers", rowSpan: 2 },
    { content: "Trade / Legal Name", rowSpan: 2 },
    { content: "Invoice Detail", colSpan: 4 },
    { content: "Place of Suppliers", rowSpan: 2 },
    { content: "Supply Attract Reverse Charges", rowSpan: 2 },
    { content: "Rate(%)", rowSpan: 2 },
    { content: "HSN/SAC", rowSpan: 2 },
    { content: "Taxable Value", rowSpan: 2 },
    { content: "Tax Amount", colSpan: 3 },
  ];

  const columnsB = [
    { content: "Invoice Number" },
    { content: "Invoice Type" },
    { content: "Invoice Date" },
    { content: "Invoice Value" },
    { content: "Integrated Tax" },
    { content: "Central Tax" },
    { content: "State/UT Tax" },
  ];

  const headCols = [columnsA, columnsB];

  const fieldMapping = {
    "GSTIN of Suppliers": (item: any) => item?.partyGSTNo,
    "Trade / Legal Name": (item: any) => item?.partyName,
    "Invoice Number": (item: any) => item?.number,
    "Invoice Type": (item: any) => item?.voucherType,
    "Invoice Date": (item: any) => item?.date,
    "Invoice Value": (item: any) => item?.invoiceValue,
    "Place of Suppliers": (item: any) => item?.supplyState,
    "Supply Attract Reverse Charges": (item: any) => "No",
    "Rate(%)": (item: any) => item?.rate,
    "HSN/SAC": (item: any) => item?.hsnsac,
    "Taxable Value": (item: any) => item?.taxableAmount,
    "Integrated Tax": (item: any) => item?.igstAmt,
    "Central Tax": (item: any) => item?.cgstAmt,
    "State/UT Tax": (item: any) => item?.sgstAmt,
  };

  let type = 1;

  const exportCsv = (exportData: any[]) => {
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      filterDate,
      path,
      currentClient?.businessName,
      type
    );
    setExportType(0);
  };

  const exportPDF = (exportData: any[]) => {
    InvoiceExportService.generatePDF(
      exportData,
      currentClient?.businessName,
      headCols,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path,
      null,
      type,
      "landscape"
    );
    setExportType(0);
  };

  const exportExcel = async (exportData: any[]) => {
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      headCols,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path,
      null,
      type
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportGstData.length > 0) {
              exportCsv(exportGstData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportGstData.length > 0) {
              exportPDF(exportGstData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportGstData.length > 0) {
              exportExcel(exportGstData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <div>
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined />}
        style={{
          justifyContent: "center",
          marginTop: "180px",
          textAlign: "center",
        }}
      >
        <Card
          className="ca-card-body"
          style={{
            boxShadow: "0px 0px 10px 0px #96A1C84D",
            height: "90vh",
            overflowY: "scroll",
            padding: "20px 30px 60px 30px",
          }}
        >
          <Row
            gutter={10}
            justify={"space-between"}
            style={{ marginBottom: "10px" }}
          >
            <Col>
              <span
                style={{ fontSize: "large", color: `${themeData?.themeColor}` }}
              >
                GST Reports
              </span>
            </Col>
            <Col>
              <Row gutter={10} justify={"end"}>
                <Col>
                  <DatePicker
                    format="MMM-YY"
                    picker="month"
                    allowClear={false}
                    minDate={dayjs(companySettings?.period?.from)}
                    maxDate={dayjs(companySettings?.period?.to)}
                    onChange={(e: any) => {
                      if (e === null) {
                        setFilterDate({});
                      } else {
                        console.log("Date Value", e);

                        setFilterDate({
                          ...filterDate,
                          from: dayjs(e).startOf("M").format("DD/MM/YYYY"),
                          to: dayjs(e)
                            .startOf("M")
                            .add(1, "M")
                            .add(-1, "D")
                            .format("DD/MM/YYYY"),
                        });
                      }
                      // openNotification("success", `Period locked.`);
                      setExportGstData([]);
                      setExportType(-1);
                    }}
                    style={{
                      // width:
                      //   width <= 464 ? "210px" : width == 375 ? "200px" : "250px",
                      border: "1px solid #f1f3ff",
                    }}
                  />
                </Col>
                {/* { findUserOnlyOnePremission(
                           "Report.GST.View",
                          currentClient?.id!
                        )&& ( */}

                {/* <Col>
                  {gstTable4AReportsData?.length === 0 ||
                  gstTable5ReportsData?.length === 0 ||
                  gstTable7AReportsData?.length === 0 ? (
                    <>
                      <Button
                        type="default"
                        icon={<DownloadOutlined />}
                        disabled
                      >
                        Export
                      </Button>
                    </>
                  ) : (
                    <>
                      <Popover
                        content={content}
                        placement="rightTop"
                        trigger="hover"
                      >
                        <Button
                          disabled //TODO: After completion of reports, need to enable
                          type="default"
                          icon={<DownloadOutlined />}
                          // onClick={() => exportCsv()}
                        >
                          Export
                        </Button>
                      </Popover>
                    </>
                  )}
                </Col> */}

                {/* )} */}
              </Row>
            </Col>
          </Row>
          <Row gutter={20} style={{ marginBottom: "20px" }}>
            <Col span={4} style={{}}>
              <Card
                title="GSTR-1"
                bordered={false}
                style={{
                  boxShadow: "0px 0px 2px 1px #96A1C84D",
                  backgroundColor: `${
                    selReport === "GST1" ? themeData?.themeColor + "20" : ""
                  }`,
                }}
              >
                <Row
                  gutter={10}
                  justify={"space-between"}
                  style={{
                    height: "120px",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  <Col style={{ height: "70%", width: "100%" }}>
                    Summary of all outward supplies
                  </Col>
                  <Col style={{ height: "30%", width: "100%" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setSelReport("GST1");
                      }}
                    >
                      View Report
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col span={4}>
              <Card
                title="GSTR-2"
                bordered={false}
                style={{
                  boxShadow: "0px 0px 2px 1px #96A1C84D",
                  backgroundColor: `${
                    selReport === "GST2A" ? themeData?.themeColor + "20" : ""
                  }`,
                }}
              >
                <Row
                  gutter={10}
                  justify={"space-between"}
                  style={{
                    height: "120px",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  <Col style={{ height: "70%", width: "100%" }}>
                    Summary of all inward supplies with ITC and Credit/Debit
                    note detail
                  </Col>
                  <Col style={{ height: "30%", width: "100%" }}>
                    <Button
                      type="primary"
                      onClick={() => setSelReport("GST2A")}
                    >
                      View Report
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col span={4}>
              <Card
                title="GSTR-3"
                bordered={false}
                style={{
                  boxShadow: "0px 0px 2px 1px #96A1C84D",
                  backgroundColor: `${
                    selReport === "GST3B" ? themeData?.themeColor + "20" : ""
                  }`,
                }}
              >
                <Row
                  gutter={10}
                  justify={"space-between"}
                  style={{
                    height: "120px",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  <Col style={{ height: "70%", width: "100%" }}>
                    Summary of all supplies
                  </Col>
                  <Col style={{ height: "30%", width: "100%" }}>
                    <Button
                      type="primary"
                      onClick={() => setSelReport("GST3B")}
                    >
                      View Report
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          {/* GSTR-1 Tables */}
          {/* Table 4, 5, 6, 7 and 8 */}
          {selReport === "GST1" && (
            <GSTR1
              gstTable4AReportsData={gstTable4AReportsData}
              gstTable4BReportsData={gstTable4BReportsData}
              gstTable5ReportsData={gstTable5ReportsData}
              gstTable6AReportsData={gstTable6AReportsData}
              gstTable6BReportsData={gstTable6BReportsData}
              gstTable6CReportsData={gstTable6CReportsData}
              gstTable7AReportsData={gstTable7AReportsData}
              gstTable7BReportsData={gstTable7BReportsData}
              gstTable8ReportsData={gstTable8ReportsData}
            />
          )}

          {/* GSTR-2 Tables */}
          {/* Table 2A */}
          {selReport === "GST2A" && (
            <GSTR2A
              gst2ATable3ReportsData={gst2ATable3ReportsData}
              gst2ATable4ReportsData={gst2ATable4ReportsData}
            />
          )}

          {/* GSTR-3 Tables */}
          {/* Table 3B */}
          {selReport === "GST3B" && <div>GST 3 Reports</div>}
        </Card>
      </Spin>
    </div>
  );
};

export default GSTReports;
